import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  TuiCalendarModule,
  TuiHintModule,
  TuiPrimitiveYearMonthPaginationModule,
  TuiTextfieldControllerModule
} from "@taiga-ui/core";
import {
  TuiInputDateModule,
  TuiUnfinishedValidatorModule
} from "@taiga-ui/kit";
import { KwikUIInputDateComponent } from "./input-date.component";

@NgModule({
  declarations: [KwikUIInputDateComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TuiCalendarModule,
    TuiHintModule,
    TuiInputDateModule,
    TuiPrimitiveYearMonthPaginationModule,
    TuiTextfieldControllerModule,
    TuiUnfinishedValidatorModule
  ],
  exports: [KwikUIInputDateComponent]
})
export class KwikUIInputDateModule {}
